var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group text-center suspended-alert"},[_c('label',{staticClass:"text-danger small"},[_c('img',{staticClass:"warning-icon",attrs:{"alt":"","src":require("../../../assets/img/auth/warning.svg")}}),_vm._t("message")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }